import { Component, OnInit } from '@angular/core';
import { DataService } from '../shared/dataservice.service';
import { GenService } from '../shared/gen-ser.service';

@Component({
  selector: 'app-gemba-card',
  templateUrl: './gemba-card.component.html',
  styleUrls: ['./gemba-card.component.css']
})
export class GembaCardComponent implements OnInit {
   filter:any;
   currMonthDtObj:Date;
   tmpCurrMonth:Date;
   tmpDate:number = new Date().getTime();
   qualityData:any;
   materialData:any;
   testingData:any;
   safetyData:any;
   producttype:any;
  constructor(public _dataService:DataService) { }

  ngOnInit() {
    this.currMonthDtObj = new Date();
    this.tmpCurrMonth = new Date(this.currMonthDtObj);
  //  this.tmpDate = new Date();
      setTimeout(()=>{
        if(this._dataService.producttype){
          this.producttype = this._dataService.producttype[0].productId;
          this.getGembaCardsData(this.currMonthDtObj,this.producttype);  
        }     
      },300)
  }
  getSelectedMonth(){
    //this.tmpDate = this.tmpDate;
    //console.log(this.currMonthDtObj)
    return this.tmpDate;
  }

  public prevMonthSel():void{  
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() - 1);
    this.tmpCurrMonth = new Date(this.currMonthDtObj);
    this.tmpDate = this.currMonthDtObj.getTime();
    this.getGembaCardsData(this.currMonthDtObj,this.producttype);

    //this.currMonthDtObj = this.tmpDate;
  }
  nextMonthSel(){    
    this.currMonthDtObj.setMonth(this.currMonthDtObj.getMonth() + 1); 
    this.tmpCurrMonth = new Date(this.currMonthDtObj);
    this.tmpDate = this.currMonthDtObj.getTime(); 
    this.getGembaCardsData(this.currMonthDtObj,this.producttype);
  }
  formatMonth(_dateObj:Date):string{
    if(_dateObj){
      return GenService.getDateFormatStr(_dateObj , "MMM-YYYY");
    }
    return '-';
  }
  checkWindowSize():string{
    if(window.screen.height<= 768 && window.screen.width<= 1366){
       return 'col-lg-8'
    }
    else{
      return 'col-lg-11'
    }
  }
  setFilterSize():string{
    if(window.screen.height<= 768 && window.screen.width<= 1366){
      return 'col-lg-2'
   }
   else{
     return 'col-lg-1'
   }
  }

  getGembaCardsData(dt,pt){

    this._dataService.getGembaCardsData(dt,pt).subscribe((_doc:any) => {
      let qualityFound = false;
      let materialFound = false;
      let testingFound = false;
      let safetyFound = false;
      if(_doc.data){
        for(var i=0;i<_doc.data.length;i++){
          if(_doc.data[i].type == 'Quality'){
            this.qualityData = _doc.data[i];
            this.qualityData.id = _doc.id;
            this.qualityData.ts = _doc.ts;
            qualityFound = true;
          }
          else if(_doc.data[i].type == 'Material'){
            this.materialData = _doc.data[i];
            this.materialData.id = _doc.id;
            this.materialData.ts = _doc.ts;
            materialFound = true;
          }
          else if(_doc.data[i].type == 'Safety'){
            this.safetyData = _doc.data[i];
            this.safetyData.id = _doc.id;
            this.safetyData.ts = _doc.ts;
            safetyFound = true;
          }
          else if(_doc.data[i].type == 'Testing'){
            this.testingData = _doc.data[i];
            this.testingData.id = _doc.id;
            this.testingData.ts = _doc.ts;
            testingFound = true;
          }
        }
      }     
      if(!qualityFound){
        this.qualityData ={};
        this.qualityData.id = _doc.id;
        this.qualityData.type = "Quality";
        this.qualityData.ts = _doc.ts;
      }
      if(!materialFound){
        this.materialData = {};
        this.materialData.type = "Material"
        this.materialData.id = _doc.id;
        this.materialData.ts = _doc.ts;
      }
      if(!testingFound){
        this.testingData = {};
        this.testingData.type = "Testing";
        this.testingData.id = _doc.id
        this.testingData.ts = _doc.ts;
      }
      if(!safetyFound){
        this.safetyData = {};
        this.safetyData.type = "Safety";
        this.safetyData.id = _doc.id;
        this.safetyData.ts = _doc.ts;
      }
    });
  }
}
